// Mobile landscape images
for (const image of document.querySelectorAll('.single-image__mobile-landscape picture')) {
	let prevScroll = 0;

	const imageElem = image.querySelector('img');
	const container = image.closest('.single-image__mobile-landscape');
	const parent = image.closest('.single-image__parent-container');

	function easeInOutQuad(x) {
		return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
	}

	const animate = () => {
		if (window.innerWidth < 992 && container.offsetTop != parent.offsetTop && container.getBoundingClientRect().top > 0) {
			let scrollAmount = (container.offsetTop - parent.offsetTop) / (parent.clientHeight - container.clientHeight);
		
			scrollAmount -= 0.05;
			scrollAmount = scrollAmount / 0.92;
			scrollAmount = Math.max(0, Math.min(scrollAmount, 1));
			const transformAmount = (imageElem.scrollWidth - image.clientWidth) / imageElem.scrollWidth;
			const transformVal = scrollAmount * transformAmount;

			if (scrollAmount != prevScroll) {
				imageElem.style.transform = `translateX(-${transformVal * 100}%)`;
				prevScroll = scrollAmount;
			}
		}

		requestAnimationFrame(animate);
	}

	animate();
}